<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-6">
        <vue-drag-tree
          :data="treeModel"
          :allowDrag="allowDrag"
          :allowDrop="allowDrop"
          :defaultText="'New Node'"
          :displayCheckBox="displayCheckBox"
          :createNodeFlag="true"
          :deleteNodeFlag="true"
          @current-node-clicked="curNodeClicked"
          @drag="dragHandler"
          @drag-enter="dragEnterHandler"
          @drag-leave="dragLeaveHandler"
          @drag-over="dragOverHandler"
          @drag-end="dragEndHandler"
          @drop="dropHandler"
          @createNode="onCreateNode"
          @deleteNode="onDeleteNode"
        >
          <!-- <span :class="[slotProps.isClicked ? 'i-am-clicked' : 'i-am-not-clicked']"></span> -->
          <!-- <span class="text">{{ slotProps.nodeName }}</span> -->
        </vue-drag-tree>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <validationObserver ref="createView">
              <b-form @submit.prevent="onSave">
                <validationProvider
                  v-slot="{ errors }"
                  name="View Name"
                  :rules="{ required: true,
                            duplicateName: [isDuplicateViewName, 'View Name is duplicate'] }"
                >
                  <b-form-group
                    label="View Name"
                    label-for="viewName"
                    label-cols-sm="3"
                  >
                    <b-form-input
                      id="viewName"
                      type="text"
                      v-model="input.view_name"
                      :class="{ 'is-invalid': errors.length }"
                      @keyup="checkDuplicateName(input.view_name, '')"
                    ></b-form-input>
                    <div
                      v-if="errors.length"
                      class="validate-invalid"
                    >
                      <span>{{
                        errors[0]
                      }}</span>
                    </div>
                  </b-form-group>
                </validationProvider>
                <hr/>
                <validationProvider
                  v-slot="{ errors }"
                  name="Display Name(EN)"
                  :rules="{ required: true,
            duplicateName: [isDuplicateEN, 'Display Name(EN) is duplicate'], }"
                >
                  <b-form-group
                    label="Display Name(EN)"
                    label-for="displayNameEN"
                    label-cols-sm="3"
                  >
                    <b-form-input
                      id="displayNameEN"
                      type="text"
                      v-model="input.display_name.en"
                      :class="{ 'is-invalid': errors.length }"
                      @keyup="checkDuplicateName(input.display_name.en, 'en')"
                    ></b-form-input>
                    <div
                      v-if="errors.length"
                      class="validate-invalid"
                    >
                      <span>{{
                        errors[0]
                      }}</span>
                    </div>
                  </b-form-group>
                </validationProvider>

                <validationProvider
                  v-slot="{ errors }"
                  name="Display Name(TH)"
                  :rules="{ required: true,
            duplicateName: [isDuplicateTH, 'Display Name(TH) is duplicate'] }"
                >
                  <b-form-group
                    label="Display Name(TH)"
                    label-for="displayNameTH"
                    label-cols-sm="3"
                  >
                    <b-form-input
                      id="displayNameTH"
                      type="text"
                      v-model="input.display_name.th"
                      :class="{ 'is-invalid': errors.length }"
                      @keyup="checkDuplicateName(input.display_name.th, 'th')"
                    ></b-form-input>
                    <div
                      v-if="errors.length"
                      class="validate-invalid"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </validationProvider>
                <hr/>
                <validationProvider
                  v-slot="{ errors }"
                  name="Route Name"
                  :rules="{ required: true }"
                >
                  <b-form-group
                    class="mb-4"
                    label="Route Name"
                    label-for="route-name-input"
                    label-cols-sm="3"
                  >
                    <b-form-input
                      id="route-name-input"
                      v-model="input.route_name"
                      :class="{ 'is-invalid': errors.length }"
                    ></b-form-input>
                    <div v-if="errors.length" class="validate-invalid">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </validationProvider>

                <b-form-group
                  class="mb-4"
                  label="Route Url"
                  label-for="route-url-input"
                  label-cols-sm="3"
                >
                  <b-form-input
                    id="route-url-input"
                    v-model="input.route_url"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  class="mb-4"
                  label="Visible"
                  label-for="visible"
                  label-cols-sm="3"
                >
                  <div class="radio-inline">
                    <b-form-radio
                      v-model="input.is_visible"
                      class="custom-radio mb-3"
                      :value="true"
                      >Show</b-form-radio
                    >
                    <b-form-radio
                      v-model="input.is_visible"
                      class="custom-radio mb-3"
                      :value="false"
                      >Hide</b-form-radio
                    >
                  </div>
                </b-form-group>

                <b-form-group
                  class="mb-4"
                  label="Is Title"
                  label-for="visible"
                  label-cols-sm="3"
                >
                  <div class="radio-inline">
                    <b-form-radio
                      v-model="input.is_title"
                      class="custom-radio mb-3"
                      :value="true"
                      >Yes</b-form-radio
                    >
                    <b-form-radio
                      v-model="input.is_title"
                      class="custom-radio mb-3"
                      :value="false"
                      >No</b-form-radio
                    >
                  </div>
                </b-form-group>

                <b-form-group
                  class="mb-4"
                  label="Glyphicon"
                  label-for="glyphicon-input"
                  label-cols-sm="3"
                >
                  <b-form-input
                    id="glyphicon-input"
                    v-model="input.icon"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  class="mb-4"
                  label="Sequence"
                  label-for="sequence"
                  label-cols-sm="3"
                >
                  <b-form-input
                    id="sequence"
                    v-model="input.sequence"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  class="mb-4"
                  label="Command ID"
                  label-for="commandId"
                  label-cols-sm="3"
                >
                  <b-form-input
                    id="commandId"
                    v-model="input.command_id"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  class="mb-4"
                  label="View Type"
                  label-for="device_type"
                  label-cols-sm="3"
                >
                  <div class="radio-inline">
                    <b-form-radio
                      v-model="input.device_type"
                      class="custom-radio mb-3"
                      value="All"
                      >All</b-form-radio
                    >
                    <b-form-radio
                      v-model="input.device_type"
                      class="custom-radio mb-3"
                      value="Web"
                      >Web</b-form-radio
                    >
                    <b-form-radio
                      v-model="input.device_type"
                      class="custom-radio mb-3"
                      value="Mobile"
                      >Mobile</b-form-radio
                    >
                  </div>
                </b-form-group>
                <validationProvider
                  v-slot="{ errors }"
                  name="View Status"
                  :rules="{ required: true }"
                >
                  <b-form-group
                    class="mb-4"
                    label="View Status"
                    label-for="viewStatus"
                    label-cols-sm="3"
                  >
                    <multiselect
                      v-model="input.status"
                      :options="viewStatus"
                      :class="{ 'is-invalid': errors.length }"
                    ></multiselect>
                    <div v-if="errors.length" class="validate-invalid">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </b-form-group>
                </validationProvider>
                <button
                  type="submit"
                  class="btn btn-primary mr-1"
                  style="float: right"
                  v-if="input.view_id !== null"
                >
                  Save
                </button>
              </b-form>
            </validationObserver>
          </div>
        </div>
      </div>
    </div>
    <modal-create-view
      :activeModal="modal.createView"
      :applicationId="this.GET_APPLICATION_SELECTED.id"
      @hidden="modal.createView = false"
      @createView="createView"
    ></modal-create-view>
    <confirm-modal
      :show="modal.confirm"
      bodyText="Confirm update"
      @hidden="modal.confirm = false"
      @confirm="updateView"
    ></confirm-modal>
    <confirm-delete-modal
      :show="modal.deleteView"
      :bodyText="'Confirm delete'"
      @hidden="modal.deleteView = false"
      @confirm="deleteView"
    ></confirm-delete-modal>
  </Layout>
</template>
<script>
import VueDragTree from "@/libs/vue-drag-tree/src/VueDragTree";
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import viewProvider from "@/helpers/service/view-provider";
import { applicationComputed } from "@/state/helpers";
import modalCreateView from "@/components/view-interface/modalCreateView";
import ConfirmModalComponnent from "@/components/share/modal-confirm.vue";
import ConfirmDeleteModalComponnent from "@/components/share/modal-confirm-delete.vue";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Layout,
    PageHeader,
    Multiselect,
    "vue-drag-tree": VueDragTree,
    "modal-create-view": modalCreateView,
    "confirm-modal": ConfirmModalComponnent,
    "confirm-delete-modal": ConfirmDeleteModalComponnent,
  },
  data() {
    return {
      title: "Views Interface",
      items: [],
      treeModel: [
        {
          view_name: "Root",
          display_name: {
            th: "Root",
            en: "Root"
          },
          sequence: 0,
          route_name: "",
          route_url: "",
          icon: "",
          status: "Active",
          is_visible: true,
          is_title: false,
          command_id: "",
          device_type: "All",
          items: null,
          viewId: null,
          view_id: null,
          parent_id: null,
          level: 0,
        },
      ],
      modal: {
        createView: false,
        deleteView: false,
        confirm: false,
      },
      input: {
        view_name: "Root",
        display_name: {
          th: "Root",
          en: "Root"
        },
        sequence: 0,
        route_name: "",
        route_url: "",
        icon: "",
        status: "Active",
        is_visible: true,
        is_title: false,
        command_id: "",
        device_type: "All",
        items: null,
        viewId: null,
        view_id: null,
      },
      input_temp: {
        view_name: "",
        display_name: {
          th: "",
          en: ""
        },
      },
      displayCheckBox: false,
      viewStatus: ["Active", "Delete"],
      isDuplicateEN: false,
      isDuplicateTH: false,
      isDuplicateViewName: false,
      seletedViewId: "",
      parent_id: null,
      level: 0,
      isCreateFormRoot: false,
    };
  },
  async mounted() {
    await this.getTreeModel();
  },
  computed: {
    ...applicationComputed,
  },
  methods: {
    displayName(item) {
      if(this.$validate.isObjectValid(item.display_name)) {
        if (this.$validate.isTrimValid(item.display_name.en)) {
          return item.display_name.en
        } else if (this.$validate.isTrimValid(item.display_name.th)) {
          return item.display_name.th
        }
      }
      return item.view_name
    },
    onSave() {
      this.$refs.createView.validate().then((result) => {
       // console.log(result);
        if (result) this.modal.confirm = true;
      });
    },
    onCreateNode(model) {
      // console.log(model);
      this.modal.createView = true;
      this.parent_id = model.view_id === "" ? null : model.view_id;
      this.level = model.level;
      this.isCreateFormRoot = this.displayName(model) === "Root";
    },
    onDeleteNode(model) {
    //  console.log("model", model);
      this.modal.deleteView = true;
      this.seletedViewId = model.view_id;
    },
    async checkDuplicateName(viewName, lang) {
      this.isDuplicateEN = false;
      this.isDuplicateTH = false;
      this.isDuplicateViewName = false;

      const params = new URLSearchParams();
      if (lang == 'en') {
        if (this.input_temp.display_name.en == viewName) {
          return
        }
        params.append("display_name.en", viewName);
      } else if (lang == 'th') {
        if (this.input_temp.display_name.th == viewName) {
          return
        }
        params.append("display_name.th", viewName);
      } else {
        if (this.input_temp.view_name == viewName) {
          return
        }
        params.append("view_name", viewName);
      }

      let result = await viewProvider.checkDuplicateViewAsync(
        this.GET_APPLICATION_SELECTED.id,
        params
      );
      if (result.status === 200) {
        if (lang == 'en') {
          this.isDuplicateEN = true;
        } else if (lang == 'th') {
          this.isDuplicateTH = true;
        } else {
          this.isDuplicateViewName = true;
        }
      } else if (result.response.status === 404) {
        if (lang == 'en') {
          this.isDuplicateEN = false;
        } else if (lang == 'th') {
          this.isDuplicateTH = false;
        } else {
          this.isDuplicateViewName = false;
        }
      }
    },
    async getTreeModel() {
      let params = new URLSearchParams();
      params.append("no-cache", 1);
      let result = await viewProvider.getViewAsync(
        this.GET_APPLICATION_SELECTED.id,
        params
      );
      // console.log("result", result);
      if (result.status === 200) {
        if (result.data.length) this.treeModel[0].items = result.data;
      }
    },
    async getViewById(viewId, isNoCache) {
      let params = new URLSearchParams();
      if (isNoCache) params.append("no-cache", 1);
      let result = await viewProvider.getViewByIdAsync(
        this.GET_APPLICATION_SELECTED.id,
        viewId,
        params
      );
      // console.log("result", result);
      if (result.status === 200) {
        this.input = result.data;
        this.input_temp = {
          view_name: this.input.view_name,
          display_name: {
            th: this.input.display_name.th,
            en: this.input.display_name.en
          }
        }
      }
    },
    async createView(body) {
      let apiData = body;
      apiData.level = !this.isCreateFormRoot ? this.level + 1 : 0;
      apiData.parent_id = this.parent_id;
      // console.log('apiData', apiData)
      let result = await viewProvider.createViewAsync(
        this.GET_APPLICATION_SELECTED.id,
        apiData
      );
      if (result.status === 201) {
        await this.getTreeModel();
        this.$utils.notification("success", "View is created", 1500);
      }
      this.modal.createView = false;
    },
    async updateView() {
      // console.log("updateView", this.input);
      let result = await viewProvider.updateViewAsync(
        this.GET_APPLICATION_SELECTED.id,
        this.input
      );
      this.modal.confirm = false;
      if (result.status === 204) {
        await this.getViewById(this.input.view_id, true);
        await this.getTreeModel();
        this.$utils.notification("success", "View is updated", 1500);
      }
    },
    async deleteView() {
      let result = await viewProvider.deleteViewAsync(
        this.GET_APPLICATION_SELECTED.id,
        this.seletedViewId
      );
      if (result.status === 200) {
        await this.getTreeModel();
        this.$utils.notification("success", "View is deleted", 1500);
      }
      this.modal.deleteView = false;
    },
    allowDrag(model, component) {
      // if (model.name === "Node 0-1") {
      //   // can't be dragged
      //   return false;
      // }
      // // can be dragged
      // return true;
      return false;
    },
    allowDrop(model, component) {
      // if (model.name === "Node 2-2") {
      //   // can't be placed
      //   return false;
      // }
      // // can be placed
      // return true;
      return false;
    },
    async curNodeClicked(model, component) {
      // console.log("curNodeClicked", model, component);
      if (model.view_id !== null) {
        await this.getViewById(model.view_id, true);
      }
    },
    dragHandler(model, component, e) {
      // console.log('dragHandler: ', model, component, e);
    },
    dragEnterHandler(model, component, e) {
      // console.log('dragEnterHandler: ', model, component, e);
    },
    dragLeaveHandler(model, component, e) {
      // console.log('dragLeaveHandler: ', model, component, e);
    },
    dragOverHandler(model, component, e) {
      // console.log('dragOverHandler: ', model, component, e);
    },
    dragEndHandler(model, component, e) {
      // console.log('dragEndHandler: ', model, component, e);
    },
    dropHandler(model, component, e) {
      // console.log('dropHandler: ', model, component, e);
    },
  },
};
</script>
